import React from "react";
import { GrCircleQuestion } from "react-icons/gr";
import { Tooltip as TooltipLib } from "@npm_leadtech/qr-ui-components";

export const InputTooltipHelper = ({ helper }) => {
  const { item, tooltip } = helper;
  const { text, position } = tooltip;

  const icon = (item) => {
    if (item === "help") return <GrCircleQuestion className="helper-icon" />;
  };

  return (
    <TooltipLib
      dataQA="input-tooltip"
      dataTestId="tooltip"
      text={text}
      position={position}
    >
      {icon(item)}
    </TooltipLib>
  );
};
